const ACCOUNT_STATUSES = new Set(["READY", "FAILED_RETRYABLE", "NOT_CONFIGURED", "IDENTITY_CONFLICT"]);

export function normalizeNotificationAccountStatus(value) {
  const status = String(value || "NOT_CONFIGURED").toUpperCase();
  if (!ACCOUNT_STATUSES.has(status)) {
    throw new Error("Notification account returned an unknown status.");
  }
  return status;
}

export function canConnectNotification({ accountStatus, channelEligible, stale }) {
  return !stale && accountStatus === "READY" && Boolean(channelEligible);
}

export function notificationSubscriptionUri(record, publicUrl) {
  if (!record || String(record.provider || "").toLowerCase() !== "ntfy"
      || String(record.lifecycle_state || "").toUpperCase() !== "ACTIVE") return "";
  try {
    const canonical = new URL(publicUrl);
    const endpoint = new URL(record.provider_endpoint_ref);
    const topic = String(record.provider_topic || "");
    if (canonical.protocol !== "https:" || canonical.username || canonical.password
        || canonical.search || canonical.hash || canonical.pathname !== "/"
        || endpoint.origin !== canonical.origin || endpoint.protocol !== "https:"
        || endpoint.username || endpoint.password || endpoint.pathname !== "/"
        || endpoint.search || endpoint.hash || !/^[A-Za-z0-9_-]+$/.test(topic)) return "";
    const display = String(record.channel || "Notifications").replaceAll("-", " ");
    return `ntfy://${canonical.host}/${encodeURIComponent(topic)}?display=${encodeURIComponent(display)}`;
  } catch {
    return "";
  }
}

export function isSafeNotificationUri(uri, publicUrl) {
  if (typeof uri !== "string" || !uri) return false;
  try {
    const canonical = new URL(publicUrl);
    const candidate = new URL(uri);
    const displayOnly = candidate.searchParams.size === 1 && candidate.searchParams.has("display");
    return canonical.protocol === "https:" && candidate.protocol === "ntfy:"
      && candidate.host === canonical.host && !candidate.username && !candidate.password
      && displayOnly && !candidate.hash && /^\/[A-Za-z0-9_-]+$/.test(candidate.pathname);
  } catch {
    return false;
  }
}
